import styled from 'styled-components';

export const InvestmentSummaryCardStyles = styled.div`
	overflow: hidden;
	border-radius: 0.5rem;
	background: ${({ theme }) => theme.v3.colors.dark[8]};

	.content {
		padding: 0.5rem 0.5rem 0;
	}

	.meta {
		margin-bottom: 0.5rem;
		border-bottom: 1px solid ${({ theme }) => theme.v3.colors.dark[4]};
		padding: 0.5rem 0.5rem 0.75rem;
	}

	.rows {
		padding: 0 0.5rem;
	}

	.actions {
		margin-top: 0.5rem;
		border-top: 1px solid ${({ theme }) => theme.v3.colors.dark[4]};
		padding: 0.75rem;

		&.released {
			display: flex;
			justify-content: center;
			align-items: center;
			min-height: 3.5rem;
			background: ${({ theme }) => theme.v3.colors.teal[9]};
		}
	}

	.released-text {
		display: flex;
		align-items: center;
		gap: 0.5rem;

		&:before {
			content: '';
			display: inline-block;
			width: 0.5rem;
			height: 0.5rem;
			border-radius: 50%;
			background: ${({ theme }) => theme.v3.colors.teal[8]};
		}
	}
`;
